<template>
    <div class="container">
        <section id="onibi-one" :class="['section', 'column-desing']">
            <h1 class="titleWhite">Pronto, cada espacio tendrá su propio control… y tú estarás al mando.</h1>
            <div class="gif-simulado">
                <img src="../assets/onibiOne.svg" alt="One">
                <img src="../assets/onibiTwo.svg" alt="Two">
                <img src="../assets/onibiThree.svg" alt="Three">
            </div>
            <img id="ONIBI" src="../assets/ONIBI.svg" alt="Onibi">
        </section>
    </div>
</template>

<script>
    export default {
        name: 'OnibiPage',
        methods: {
            onibi() {
                this.$emit('active-onibi');
            },
        },
};
</script>

<style scoped>
.titleWhite{
  text-align: center;
}
#onibi-one {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  min-height: 100vh;
}

#ONIBI {
  width: 30vw;
  margin: 0 auto;
}

.gif-simulado {
  position: relative;
  width: 40vw;
  height: 40vw;
  margin: 0vw auto;
}

.gif-simulado img {
  position: absolute;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);
}

.gif-simulado img:nth-child(1) {
  opacity: 1;        
  animation: none;
  z-index: 1;
}

.gif-simulado img:nth-child(2) {
  animation-delay: 0s;
  z-index: 2;
  animation: ciclo 1s infinite;
}

.gif-simulado img:nth-child(3) {
  animation-delay: 1s;
  z-index: 3;
  animation: ciclo2 1s infinite;
}

@keyframes ciclo {
  0%   { opacity: 0; }
  10%  { opacity: 1; }
  30%  { opacity: 1; }
  40%  { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes ciclo2 {
  0%   { opacity: 0; }
  10%  { opacity: 0; }
  30%  { opacity: 1; }
  90%  { opacity: 1; }
  100% { opacity: 0; }
}
@media (max-width: 800px) {
  .titleWhite {
    font-size: 3rem;
  }
  .gif-simulado {
  width: 350px;
  height: 350px;
  }
  #onibi-one > img{
    width: 50%;
  }
}

@media (max-width: 550px){
  .titleWhite {
    font-size: 2rem;
  }
  #onibi-one > img{
    width: 80%;
  }
}
</style>